import { ExternalCell, ExternalRow } from '@cast/design-system';
import { SystemOverrideOrigin, SystemOverrideTarget } from '@cast/types';

import { DetailsRowContainer, DetailWitTitle } from './DetailsRowContainer';
import { OptimizationStatusDisabledChip } from './OptimizationStatusChips';
import { SystemOverrideTriggeredEvent } from '../../../types';

const getSystemOverrideOriginLabel = (origin: SystemOverrideOrigin): string => {
  switch (origin) {
    case SystemOverrideOrigin.CONTINUOUS_OOM_KILLED:
      return 'Triggered due to continuous OOMkills; Failed to fix the workload after multiple scaling attempts, and the vertical optimization is disabled temporarily.';
    case SystemOverrideOrigin.UNSPECIFIED:
      return 'Unknown';
    default:
      return origin;
  }
};

export const SystemOverrideTriggeredEventRow = (
  event: SystemOverrideTriggeredEvent
) => {
  return (
    <DetailsRowContainer event={event}>
      <ExternalRow
        height={22}
        top={-12}
        sx={{ borderTopColor: 'transparent !important' }}
      >
        <ExternalCell startColumn={0} sx={{ width: '100% !important' }}>
          <DetailWitTitle
            title="Message:"
            detail={getSystemOverrideOriginLabel(event.details.origin)}
            titleVariant="light"
          />
        </ExternalCell>
      </ExternalRow>

      {event.details.target === SystemOverrideTarget.VERTICAL_OPTIMIZATION && (
        <ExternalRow
          height={22}
          top={-12}
          sx={{ borderTopColor: 'transparent !important' }}
        >
          <ExternalCell startColumn={0}>
            <DetailWitTitle
              title="Optimization status:"
              detail={<OptimizationStatusDisabledChip />}
              titleVariant="light"
            />
          </ExternalCell>
        </ExternalRow>
      )}
    </DetailsRowContainer>
  );
};
